
const GlobalColor = {
  $grey2: '#F5F5F5',
  $grey4: '#D9D9D9',
  $4px: '4px',
  $8px: '8px',
  $burden8px: '-8px',
  $16px: '16px'
}

export { GlobalColor }
